<template>
    <div class="ChecklistShareTasksDialogRolePickerGroupMember-row py-2 px-4 ml-8">
      <div>{{member.fullName}}</div>
      <v-checkbox class="mt-0 pt-0 mx-auto"
                  density="compact"
                  hide-details
                  :model-value="responsibleIsChecked"
                  readonly
                  @click="onResponsibleClick"
      />
      <v-checkbox class="mt-0 pt-0 mx-auto"
                  density="compact"
                  hide-details
                  :model-value="validatorIsChecked"
                  readonly
                  @click="onValidatorsClick"
      />
      <v-checkbox class="mt-0 pt-0 mx-auto"
                  density="compact"
                  :disabled="isObserversCheckboxDisabled"
                  hide-details
                  :model-value="areObserversChecked"
                  readonly
                  @click="!isObserversCheckboxDisabled && onObserversClick()"
      />
    </div>
</template>

<script>
import { mapState } from 'vuex'

import {
  ADD_SELECTED_OBSERVERS_MEMBERS,
  ADD_SELECTED_RESPONSIBLES_MEMBERS, ADD_SELECTED_VALIDATORS_MEMBERS, REMOVE_SELECTED_OBSERVERS_GROUPS,
  REMOVE_SELECTED_RESPONSIBLES_GROUPS, REMOVE_SELECTED_VALIDATORS_GROUPS,
  TOGGLE_SELECTED_OBSERVERS_MEMBERS,
  TOGGLE_SELECTED_RESPONSIBLES_MEMBERS, TOGGLE_SELECTED_VALIDATORS_MEMBERS,
} from '@/store/modules/checklist/mutation_types'
export default {
  name: 'ChecklistShareTasksDialogRolePickerGroupMember',
  props: {
    mnemo: {
      type: String,
      required: true,
    },
    member: {
      type: Object,
      required: true,
    },
    group: {
      type: Object,
      required: true,
    },
    taskVisibleByAll: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    ...mapState('checklist', ['shareTaskRolePickerSelectedResponsibles', 'shareTaskRolePickerSelectedObservers', 'shareTaskRolePickerSelectedValidators']),
    isObserversCheckboxDisabled () {
      return this.responsibleIsChecked || this.validatorIsChecked || this.group.isPm || this.taskVisibleByAll
    },
    responsibleIsChecked () {
      return this.shareTaskRolePickerSelectedResponsibles.members.includes(this.member) ||
        this.shareTaskRolePickerSelectedResponsibles.groups.includes(this.group)
    },
    areObserversChecked () {
      return this.shareTaskRolePickerSelectedObservers.members.includes(this.member) ||
        this.shareTaskRolePickerSelectedObservers.groups.includes(this.group)
    },
    validatorIsChecked () {
      return this.shareTaskRolePickerSelectedValidators.members.includes(this.member) ||
        this.shareTaskRolePickerSelectedValidators.groups.includes(this.group)
    },
  },
  methods: {
    onResponsibleClick () {
      if (this.shareTaskRolePickerSelectedResponsibles.groups.includes(this.group) && !this.shareTaskRolePickerSelectedResponsibles.members.includes(this.member)) {
        this.$store.commit(`checklist/${REMOVE_SELECTED_RESPONSIBLES_GROUPS}`, this.group)
        this.group.members.forEach(member => {
          if (member.id !== this.member.id) {
            this.$store.commit(`checklist/${ADD_SELECTED_RESPONSIBLES_MEMBERS}`, member)
          }
        })
      } else {
        this.$store.commit(`checklist/${TOGGLE_SELECTED_RESPONSIBLES_MEMBERS}`, this.member)
        if (this.responsibleIsChecked && !this.areObserversChecked) {
          this.onObserversClick()
        }
      }
    },
    onObserversClick () {
      if (this.shareTaskRolePickerSelectedObservers.groups.includes(this.group) && !this.shareTaskRolePickerSelectedObservers.members.includes(this.member)) {
        this.$store.commit(`checklist/${REMOVE_SELECTED_OBSERVERS_GROUPS}`, this.group)
        this.group.members.forEach(member => {
          if (member.id !== this.member.id) {
            this.$store.commit(`checklist/${ADD_SELECTED_OBSERVERS_MEMBERS}`, member)
          }
        })
      } else {
        this.$store.commit(`checklist/${TOGGLE_SELECTED_OBSERVERS_MEMBERS}`, this.member)
      }
    },
    onValidatorsClick () {
      if (this.shareTaskRolePickerSelectedValidators.groups.includes(this.group) && !this.shareTaskRolePickerSelectedValidators.members.includes(this.member)) {
        this.$store.commit(`checklist/${REMOVE_SELECTED_VALIDATORS_GROUPS}`, this.group)
        this.group.members.forEach(member => {
          if (member.id !== this.member.id) {
            this.$store.commit(`checklist/${ADD_SELECTED_VALIDATORS_MEMBERS}`, member)
          }
        })
      } else {
        this.$store.commit(`checklist/${TOGGLE_SELECTED_VALIDATORS_MEMBERS}`, this.member)
        if (this.validatorIsChecked && !this.areObserversChecked) {
          this.onObserversClick()
        }
      }
    },
  },
}
</script>

<style scoped lang="scss">
@import "@/scss/border-tokens";

.ChecklistShareTasksDialogRolePickerGroupMember-row {
  display: grid;
  grid-template-columns: auto 180px 180px 180px;
  grid-gap: 10px;
  align-items: center;
  border: get-border();
}
</style>
